var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiscPageHeaderEllipses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 300,
    viewBox: "0 0 1440 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.679 -77.3912C561.679 153.01 748.456 339.787 978.857 339.787C1209.26 339.787 1396.04 153.01 1396.04 -77.3912C1396.04 -307.792 1209.26 -494.569 978.857 -494.569C748.456 -494.569 561.679 -307.792 561.679 -77.3912ZM742.926 -78.0539C742.926 52.1753 848.498 157.747 978.727 157.747C1108.96 157.747 1214.53 52.1753 1214.53 -78.0539C1214.53 -208.283 1108.96 -313.855 978.727 -313.855C848.498 -313.855 742.926 -208.283 742.926 -78.0539Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.231 -264.32C210.228 -35.9513 302.13 242.407 530.498 357.409C758.867 472.412 1037.23 380.511 1152.23 152.142C1267.23 -76.2267 1175.33 -354.585 946.961 -469.588C718.592 -584.59 440.234 -492.689 325.231 -264.32ZM508.16 -172.786C443.931 -45.2415 495.257 110.222 622.802 174.451C750.346 238.68 905.809 187.353 970.038 59.8089C1034.27 -67.7353 982.94 -223.198 855.396 -287.427C727.852 -351.657 572.389 -300.33 508.16 -172.786Z",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1242.92,
    y1: 230.643,
    x2: 561.679,
    y2: -77.3913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2E3192",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1384.23,
    y1: 405.754,
    x2: -37.8488,
    y2: -135.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#FF0000",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscPageHeaderEllipses);
export default __webpack_public_path__ + "static/media/miscPageHeaderEllipses.5017593da4773a9f816fcd279a2518f5.svg";
export { ForwardRef as ReactComponent };